import React from 'react';

export default function ContentManagementModal({ onClose }) {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-xl">
                <div className="mb-6 flex items-center justify-between gap-4 text-left"><h2 className="text-2xl font-bold text-slate-900">Content Management</h2><button type="button" onClick={onClose} className="inline-flex shrink-0 items-center gap-2 rounded-2xl bg-slate-800 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-900" aria-label="Back to dashboard"><span className="text-lg leading-none" aria-hidden="true">←</span> Back</button></div>
                <div className="mb-4 text-4xl">🚧</div>
                <p className="text-slate-600 mb-6">This feature is currently under development and will be available soon.</p>
            </div>
        </div>
    );
}
